import { STATUS_STYLES } from "@/lib/format";

export const StatusBadge = ({ status, testid }) => (
  <span
    data-testid={testid || `status-badge-${status}`}
    className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full border text-[11px] font-medium uppercase tracking-wide font-num ${
      STATUS_STYLES[status] || STATUS_STYLES.draft
    }`}
  >
    <span className="w-1.5 h-1.5 rounded-full bg-current" />
    {status}
  </span>
);

export default StatusBadge;
